import React from "react";
import logo from "../components/SplashScreen/img/aprann-logo.png";

export const ErrorBoundaryFallback = ({ error, eventId }) => {
	return (
		<>
			<div className="d-flex align-items-center justify-content-center vh-100 container">
				<div className="text-center">
					<img src={logo} alt="500" className="img-fluid" width="200" />
					<h1>Our apologies!</h1>
					<p className="fs-3">
						<span className="text-danger">The application has encountered an error.</span>
					</p>
					<div>
						The error has been automatically reported. If you have additional information you'd like to provide, please email{" "}
						<a href={`mailto:support@aprann.org?subject=Error:${eventId}`}>support@aprann.org</a>. and reference the Event ID
						provided below.
					</div>
					<div className="mt-3">
						<strong>Event ID: </strong>
						{eventId}
					</div>
					<div>
						<strong>Error:</strong> {error.toString()}
					</div>

					<div className="mt-3">
						{/* <button className="btn btn-outline-secondary mr-2" onClick={() => showReportDialog({ eventId })}>
							Report feedback
						</button> */}
						<a href="/" className="btn btn-primary">
							Return Home
						</a>
					</div>
				</div>
			</div>
		</>
	);
};
